document.addEventListener('DOMContentLoaded', () => {
  const loadMoreButton = document.querySelector('.collection-load-more__button');
  const productGrid = document.querySelector('#product-grid');
  const loadMoreWrapper = document.querySelector('.collection-load-more');
  const infoText = loadMoreWrapper ? loadMoreWrapper.querySelector('.collection-load-more__text') : null;
  const loadingSpinner = loadMoreButton ? loadMoreButton.querySelector('.loading__spinner') : null;

  if (!loadMoreButton || !productGrid || !loadMoreWrapper || !infoText || !loadingSpinner) return;

  let totalProducts = null;
  const totalMatch = infoText.textContent.match(/\d+\D+(\d+)\s+produtos?/);
  if (totalMatch) {
    totalProducts = parseInt(totalMatch[1], 10);
  }

  const updateInfoCount = () => {
    if (totalProducts === null) return;
    const shownCount = productGrid.querySelectorAll('li.grid__item').length;
    infoText.textContent = `Mostrando ${shownCount} de ${totalProducts} produtos`;
  };

  updateInfoCount();

  let isLoading = false;

  loadMoreButton.addEventListener('click', (event) => {
    const nextUrl = loadMoreButton.getAttribute('href');
    if (!nextUrl || isLoading) return;

    event.preventDefault();
    isLoading = true;
    loadMoreButton.classList.add('is-loading');
    loadMoreButton.setAttribute('aria-disabled', 'true');
    loadMoreButton.style.pointerEvents = 'none';
    loadingSpinner.classList.remove('hidden');

    fetch(nextUrl)
      .then((response) => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.text();
      })
      .then((htmlText) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlText, 'text/html');

        const newGrid = doc.querySelector('#product-grid');
        if (!newGrid) {
          throw new Error('Could not find product grid on next page');
        }

        const newItems = newGrid.querySelectorAll('li.grid__item');
        newItems.forEach((item) => {
          productGrid.appendChild(item);
        });

        updateInfoCount();

        const newButton = doc.querySelector('.collection-load-more__button');
        if (newButton && newButton.getAttribute('href')) {
          loadMoreButton.setAttribute('href', newButton.getAttribute('href'));
          loadMoreButton.classList.remove('is-loading');
          loadMoreButton.removeAttribute('aria-disabled');
          loadMoreButton.style.pointerEvents = '';
          loadingSpinner.classList.add('hidden');
          isLoading = false;
        } else {
          loadMoreButton.remove();
        }
      })
      .catch(() => {
        const fallbackUrl = loadMoreButton.getAttribute('href');
        loadingSpinner.classList.add('hidden');
        if (fallbackUrl) {
          window.location.href = fallbackUrl;
        }
      });
  });
});
